import { defineComponent as a, inject as s, ref as c, watchEffect as d, h as l } from "vue";
import { notificationProviderInjectionKey as f } from "./ghl-ui.es1061.js";
import m from "./ghl-ui.es994.js";
const g = a({
  name: "NotificationContainer",
  props: {
    scrollable: {
      type: Boolean,
      required: !0
    },
    placement: {
      type: String,
      required: !0
    }
  },
  setup() {
    const {
      mergedThemeRef: o,
      mergedClsPrefixRef: n,
      wipTransitionCountRef: i
    } = s(f), e = c(null);
    return d(() => {
      var r, t;
      i.value > 0 ? (r = e == null ? void 0 : e.value) === null || r === void 0 || r.classList.add("transitioning") : (t = e == null ? void 0 : e.value) === null || t === void 0 || t.classList.remove("transitioning");
    }), {
      selfRef: e,
      mergedTheme: o,
      mergedClsPrefix: n,
      transitioning: i
    };
  },
  render() {
    const {
      $slots: o,
      scrollable: n,
      mergedClsPrefix: i,
      mergedTheme: e,
      placement: r
    } = this;
    return l("div", {
      ref: "selfRef",
      class: [`${i}-notification-container`, n && `${i}-notification-container--scrollable`, `${i}-notification-container--${r}`]
    }, n ? l(m, {
      theme: e.peers.Scrollbar,
      themeOverrides: e.peerOverrides.Scrollbar,
      contentStyle: {
        overflow: "hidden"
      }
    }, o) : o);
  }
});
export {
  g as NotificationContainer
};
